import { http } from '../../config/axios'

export default function getRegistroNatureza(): Promise<any> {
  return http
    .get('api/registro/naturezas/')
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro getNatureza', error)
      throw Error(error.response.data)
    })
}
